import { required, requiredUnless, helpers, minLength, email } from '@vuelidate/validators'

const translations = {
    'fill-username': {
        'en': 'Fill your name',
        'fr': 'Entrez votre nom'
    },
    'fill-company': {
        'en': 'Fill the name of your company',
        'fr': 'Entrez le nom de votre entreprise'
    },
    'fill-role': {
        'en': 'Fill your role',
        'fr': 'Entrez votre rôle'
    },
    'fill-either-field': {
        'en': 'Fill either field',
        'fr': 'Entrez un des champs',
    },
    'fill-email': {
        'en': 'Fill your email',
        'fr': 'Entrez votre email'
    },
    'fill-email-valid': {
        'en': 'Enter a valid email',
        'fr': 'Entrez un email valide'
    },
    'fill-message': {
        'en': 'Fill your message',
        'fr': 'Entrez votre message'
    },
    'fill-files': {
        'en': 'Fill your files',
        'fr': 'Entrez vos fichiers'
    },
    'fill-deadline': {
        'en': 'Fill your deadline',
        'fr': 'Entrez votre deadline'
    },
    'fill-custom-services': {
        'en': 'Pick your custom services',
        'fr': 'Choisissez vos services personnalisés'
    },
    'fill-custom-services-min-length': {
        'en': 'Pick at least 2 custom services',
        'fr': 'Choisissez au moins 2 services personnalisés'
    },
    'fill-deadline-must-be-after': {
        'en': 'The deadline must be in the future',
        'fr': 'La deadline doit être dans le futur'
    },
    'error-file-upload': {
        'en': 'Error uploading file',
        'fr': 'Erreur de téléversement'
    },
}

const getTranslation = (key, locale) => {
    return (translations[key] && translations[key][locale]) ?? key;
}

const emptyOrArray = (value) => {
    return !value && value !== false || Array.isArray(value);
}

const mustBeAfter = (date) => {
    return (value) => {
        if (!value || !date) return false;

        // If value is from <input type="month">, expected format is "YYYY-MM"
        // Parse value as the first day of the month
        const valueDateParts = value.split("-");
        if (valueDateParts.length !== 2) return false;
        const valueDate = new Date(parseInt(valueDateParts[0]), parseInt(valueDateParts[1])-1, 1);

        // Normalize date parameter to start of its month if it's also in same format
        let compareDate = date;
        if (typeof date === "string") {
            const dateParts = date.split("-");
            if (dateParts.length === 2) {
                compareDate = new Date(parseInt(dateParts[0]), parseInt(dateParts[1])-1, 1);
            } else {
                compareDate = new Date(date);
            }
        }

        // Must be strictly after
        return valueDate > compareDate;
    }
}
export const getValidations = (slug, locale) => {
    const validations = {
        'project-username': {
            lisaUserData: {
                fullName: { required: helpers.withMessage(getTranslation('fill-username', locale), required), $autoDirty: true }
            }
        },
        'project-company': {
            lisaUserData: {
                company: { required: helpers.withMessage(getTranslation('fill-company', locale), required), $autoDirty: true },
                role: { required: helpers.withMessage(getTranslation('fill-role', locale), required), $autoDirty: true }
            }
        },
        'project-brief': {
            lisaUserData: {
                message: { requiredUnless: helpers.withMessage(getTranslation('fill-either-field', locale), requiredUnless(function() { return this.lisaUserData.files && this.lisaUserData.files.length; })), $autoDirty: true },
                files: {
                    requiredUnless: helpers.withMessage(getTranslation('fill-either-field', locale), requiredUnless(function() { return this.lisaUserData.message; })),
                    emptyOrArray: helpers.withMessage(getTranslation('error-file-upload', locale), emptyOrArray),
                    $autoDirty: true
                },
            }
        },
        'project-custom-services': {
            lisaUserData: {
                customServices: {
                    minLength: helpers.withMessage(getTranslation('fill-custom-services-min-length', locale), minLength(2)),
                    required: helpers.withMessage(getTranslation('fill-custom-services', locale), required),
                }
            }
        },
        'project-exact-deadline': {
            lisaUserData: {
                deadline: {
                    required: helpers.withMessage(getTranslation('fill-deadline', locale), required),
                    mustBeAfter: helpers.withMessage(getTranslation('fill-deadline-must-be-after', locale), mustBeAfter(new Date())),
                }
            }
        },
        'project-email': {
            lisaUserData: {
                email: { required: helpers.withMessage(getTranslation('fill-email', locale), required), email: helpers.withMessage(getTranslation('fill-email-valid', locale), email) }
            }
        },
        'quick-word-message': {
            lisaUserData: {
                message: { required: helpers.withMessage(getTranslation('fill-message', locale), required), $autoDirty: true }
            }
        },
        'quick-word-email': {
            lisaUserData: {
                email: { required: helpers.withMessage(getTranslation('fill-email', locale), required), email: helpers.withMessage(getTranslation('fill-email-valid', locale), email) }
            }
        }
    }

    return validations[slug] ? validations[slug] : { lisaUserData: {} };
}
